import Vue from 'vue'
import { PaginationPlugin } from 'bootstrap-vue'

Vue.use(PaginationPlugin)
